import React from 'react';
import _ from 'underscore';
import Buttons from './components/Buttons';
import Lists from './components/Lists';
import events from './manifest';
import isUrl from 'validate.io-uri';

import Loader from '../../../common/components/notifications/Loader';

function AdsTab (props) {
    var assets = props.assets.data.filter(function (asset) {
        return asset.type === 'video';
    });

    function handleAssetChange (ev) {
        props.push(events.editAsset(ev));
    }

    function handleAssign (asset, ev) {
        props.push(events.assignAsset(asset.assetID));
    }

    function handleCancel (ev) {
        props.push(events.removeAsset(ev.assetID));
    }

    if (props.assets.resolving.length > 0) {
        return <Loader message="Fetching" />;
    }

    var assignedAssets = props.pendingEdits.campaignAssets === undefined ?
        props.vast.data.campaignAssets :
        props.pendingEdits.campaignAssets
    ;

    var availableAssets = assets.filter(function (asset) {
        var i = _(assignedAssets).findIndex(function (_asset) {
            return _asset.assetID === asset.assetID;
        });
        return i === -1;
    });

    return <div className="ads-tab-content vast-tab-content clearfix">

        <div className="col-sm-6">
            <div className="h5">Assigned assets</div>
            <ul className="list-unstyled vast-assign-list well">
                {assignedAssets.map(function (asset, i) {
                    return <VastAsset
                        key={i}
                        asset={_(assets).findWhere({
                            assetID: asset.assetID
                        })}
                        weight={asset.weight}
                        clickURL={asset.clickURL}
                        onChange={handleAssetChange}
                        onCancel={handleCancel}
                    />;
                })}
            </ul>
        </div>

        <div className="col-sm-6">
            <div className="h5">Available assets</div>
            <ul className="list-unstyled vast-assign-list well">
                {availableAssets.map(function (asset, i) {
                    return <Lists.ListItem
                        key={i}
                        title={asset.name}
                    >
                        <Buttons.Assign
                            onClick={handleAssign.bind(null, asset)}
                        />
                    </Lists.ListItem>;
                })}
            </ul>
        </div>
    </div>;
}

// asset.fileUrl is preview URL
function VastAsset (props) {
    function handleWeightChange (ev) {
        props.onChange({
            assetID: props.asset.assetID,
            weight: Number(ev.target.value)
        });
    }

    function handleUrlChange (ev) {
        props.onChange({
            assetID: props.asset.assetID,
            clickURL: ev.target.value
        });
    }

    function handleCancel (ev) {
        ev.preventDefault();
        props.onCancel(props.asset);
    }

    var title = <div className="h5 clearfix"
        style={{ textOverflow: 'ellipsis', margin: 0 }}
    >
        <span style={{
            display: 'inline-block',
            padding: '9px 0px'
        }}>
            {props.asset.name}
        </span>
        <button type="button"
            style={{
                display: 'block',
                float: 'right'
            }}
            className="btn btn-default"
            onClick={handleCancel}
        >
            <i className="fa fa-minus"></i>
        </button>
    </div>;

    return <Lists.ListCard title={title}>
        <form
            className="vast-asset-assigned clearfix form-inline"
            style={{
                backgroundColor: 'white'
            }}
        >

            <div className="form-group">
                <label>Weight: {props.weight}</label>
                <input type="range" min="1" max="10"
                    title="weight"
                    name="ad-weight"
                    value={props.weight}
                    className="form-control"
                    onChange={handleWeightChange}
                />
            </div>

            <div className={'form-group' +
                ( (props.clickURL && !isUrl(props.clickURL)) ?
                    ' has-error' :
                    '')
            }>
                <label>Link URL {props.clickURL ? '' : ' *'}</label>
                <input type="url"
                    title="url"
                    name="ad-click-url"
                    onChange={handleUrlChange}
                    required={true}
                    placeholder="http://example.com"
                    className={'form-control'}
                    value={props.clickURL}
                />
            </div>

        </form>
    </Lists.ListCard>;
}

// VastAsset.propTypes = {
//     onCancel: pt.func.isRequired,
//     onChange: pt.func.isRequired,
//     asset: pt.object.isRequired,
//     weight: pt.oneOfType([pt.number, pt.string]),
//     clickURL: pt.string
// };

VastAsset.defaultProps = {
    weight: 5,
    clickURL: ''
};

export default AdsTab;
